module.exports = __webpack_public_path__ + "static/media/gorra (4).a5ef3575.png";